function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.45098%,47.058824%,62.745098%)",
      fillOpacity: 1
    },
    d: "M 25 10.167969 C 24.761719 10.179688 24.523438 10.179688 24.285156 10.167969 C 21.660156 10.183594 19.203125 9.09375 17.753906 7.269531 L 17.753906 17.277344 C 17.753906 21.363281 13.777344 24.675781 8.875 24.675781 C 3.972656 24.675781 0 21.363281 0 17.277344 C 0 13.195312 3.972656 9.882812 8.875 9.882812 C 9.0625 9.882812 9.246094 9.882812 9.417969 9.882812 L 9.417969 13.523438 C 9.242188 13.496094 9.058594 13.480469 8.875 13.472656 C 6.460938 13.578125 4.570312 15.238281 4.570312 17.253906 C 4.570312 19.265625 6.460938 20.929688 8.875 21.035156 C 11.40625 21.0625 13.5 19.40625 13.59375 17.300781 L 13.59375 0.304688 L 17.777344 0.304688 C 18.167969 3.429688 21.199219 5.875 24.964844 6.09375 L 24.964844 10.148438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.20ca6ff1b08194e116d8e886ce0ae5b1.svg";
export { ForwardRef as ReactComponent };